import { rem, rgba } from "polished";
import styled from "styled-components";
import media from "styled-media-query";

import Button from "components/Button";
import { themes } from "styles";

export const Container = styled.div``;

export const Notes = styled.div``;

export const Note = {
  Item: styled.div`
    padding: 24px;

    border-radius: 8px;
    border: 1px solid #edf3f5;
    box-shadow: 0 4px 4px ${rgba("#000", 0.01)};

    ${media.greaterThan("huge")`
      padding: 32px;
    `}

    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
  `,

  Title: styled.p`
    padding-bottom: 12px;

    font-weight: bold;
    font-size: ${rem("10px")};
    color: ${themes.text.high};

    ${media.greaterThan("huge")`
      padding-bottom: 16px;

      font-size: ${rem("14px")};
    `}
  `,

  Content: styled.div`
    line-height: 200%;
    font-size: ${rem("10px")};
    color: ${themes.text.high};

    ${media.greaterThan("huge")`
      font-size: ${rem("14px")};
    `}
  `,
};

export const Actions = styled.div`
  margin-top: 40px;

  display: flex;

  > button {
    flex: 1;

    &:first-of-type {
      margin-right: 16px;

      flex: 0.5;
    }
  }
`;

export const Action = styled(Button).attrs({
  type: "button",
})``;
